import React from 'react';
import './ModernBlocks.css';

const TechnologiesBlock = ({ data }) => {
  return (
    <section className="technologies-section">
      <div className="technologies-container">
        <div className="technologies-header">
          <h2 className="technologies-title">
            {data.title}
          </h2>
          <p className="technologies-subtitle">
            {data.subtitle}
          </p>
        </div>
        <div className="technologies-grid">
          {data.categories.map((category, index) => (
            <div key={index} className="technology-category">
              <h3 className="technology-category-title">
                {category.name}
              </h3>
              <div className="technology-tags">
                {category.technologies.map((tech, techIndex) => (
                  <span key={techIndex} className="technology-tag">
                    {tech}
                  </span>
                ))}
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default TechnologiesBlock; 